import { render, staticRenderFns } from "./NewSubmitOrder.vue?vue&type=template&id=4f8292a2&scoped=true"
import script from "./NewSubmitOrder.vue?vue&type=script&lang=ts"
export * from "./NewSubmitOrder.vue?vue&type=script&lang=ts"
import style0 from "./NewSubmitOrder.vue?vue&type=style&index=0&id=4f8292a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8292a2",
  null
  
)

export default component.exports